import React from "react";
import { ShieldCheck } from "lucide-react";
import { useLang } from "@/context/Lang";
import { Reveal, Overline } from "@/components/site/Reveal";

export default function Guarantee() {
  const { t } = useLang();
  return (
    <section id="guarantee" className="bg-[#F8F9FA] py-24 md:py-32" data-testid="guarantee">
      <div className="max-w-4xl mx-auto px-4 md:px-8">
        <Reveal className="relative bg-navy grain overflow-hidden border border-navy/10 p-10 md:p-16 text-center">
          <div className="relative z-10 flex flex-col items-center">
            <div className="w-20 h-20 rounded-full bg-orange/15 border border-orange/30 flex items-center justify-center">
              <ShieldCheck size={40} className="text-orange" />
            </div>
            <div className="mt-6"><Overline dark>{t.guarantee.overline}</Overline></div>
            <h2 className="mt-4 font-display font-extrabold text-white text-4xl md:text-5xl leading-[0.95] tracking-tighter max-w-2xl">
              {t.guarantee.title}
            </h2>
            <p className="mt-6 text-white/70 text-lg leading-relaxed max-w-2xl">
              {t.guarantee.body}
            </p>
          </div>
        </Reveal>
      </div>
    </section>
  );
}
